module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "no-select",
    class: {
      'drag': _vm.isDrag
    },
    staticStyle: {
      "min-height": "520px",
      "position": "relative",
      "z-index": "0"
    },
    style: (_vm.containerStyle)
  }, [_c('input-type', {
    attrs: {
      "tabInputs": _vm.tabInputs,
      "curType": _vm.curType,
      "width": "200px",
      "isDrag": _vm.isDrag
    },
    on: {
      "setIsDrag": _vm.setIsDrag,
      "setCurType": _vm.setCurType
    }
  }), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('input-list', {
    ref: "inputList",
    attrs: {
      "formName": _vm.formName,
      "inputList": _vm.submitInputs,
      "width": "calc((100% - 200px) / 2)",
      "height": "95%",
      "curType": _vm.curType,
      "curInput": _vm.curInput,
      "isDrag": _vm.isDrag
    },
    on: {
      "setCurInput": _vm.setCurInput,
      "setIsDrag": _vm.setIsDrag,
      "setCurType": _vm.setCurType
    }
  }), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('right-config', {
    attrs: {
      "curInput": _vm.curInput,
      "inputList": _vm.submitInputs,
      "width": "calc((100% - 200px) / 2)"
    }
  }), _vm._v(" "), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fl m-t-10"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.importData
    }
  }, [_vm._v("导入数据")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出数据")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "id": "copy",
      "size": "small",
      "data-clipboard-text": _vm.copyJson
    },
    on: {
      "click": _vm.copyData
    }
  }, [_vm._v("复制数据")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.importTextData
    }
  }, [_vm._v("导入文本数据")])]), _vm._v(" "), _c('div', {
    staticClass: "m-t-10 tx-c"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.goback()
      }
    }
  }, [_vm._v("返回")])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "id": "importFile",
      "type": "file"
    },
    on: {
      "change": _vm.importFileChange
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "id": "exportData",
      "href": "#",
      "download": ""
    }
  })])]), _vm._v(" "), _vm._v(" "), _c('text-import', {
    ref: "textImport",
    on: {
      "setImportText": _vm.setImportText
    }
  }), _vm._v(" "), _vm._v(" "), _vm._v(" "), (_vm.isImportConfig) ? _c('import-config-dialog', {
    ref: "importConfig",
    attrs: {
      "selectConfig": _vm.selectConfig,
      "onlyName": _vm.onlyName
    }
  }) : _vm._e(), _vm._v(" ")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-95f6c932!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Model/design.vue
// module id = 1958
// module chunks = 2